export default function migration(table: string = '_', update: boolean = false, inject: string = '') {
    table = table || '_';
    return update ?
        `
exports.up = function(knex) {
    return knex.schema.table('${table}', function (table) {
${inject}
    });
};

exports.down = function(knex) {
    return knex.schema.table('${table}', function (table) {
${inject}
    });
};`
        : `
exports.up = function(knex) {
    return knex.schema.createTable('${table}', function (table) {
      table.string('id', 25);
${inject}
      table.datetime('createdAt').defaultTo(knex.fn.now());
      table.datetime('updatedAt').defaultTo(knex.fn.now());
      table.primary('id');
    });
};

exports.down = function(knex) {
    return knex.schema.dropTable('${table}');
};`
}
